import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sidebar-section" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["label"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "form-label small d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggler = _resolveComponent("toggler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "fw-bold mb-3" }, "Impostazioni template", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label small" }, "Nome template", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control form-control-sm",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkName && _ctx.checkName(...args)))
      }, null, 544), [
        [_vModelText, _ctx.model.name]
      ]),
      (!_ctx.model.name.trim())
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Campo obbligatorio!"))
        : _createCommentVNode("", true),
      (_ctx.nameError)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.nameError), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small" }, "Formato predefinito", -1)),
      _createElementVNode("select", {
        class: "form-select form-select-sm",
        value: _ctx.selectedFormatName,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFormat(($event.target as any).value)))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("option", { value: "" }, "— Personalizzato —", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatGroups, (formats, group) => {
          return (_openBlock(), _createElementBlock("optgroup", {
            key: group,
            label: group
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formats, (f) => {
              return (_openBlock(), _createElementBlock("option", {
                key: f.name,
                value: f.name
              }, _toDisplayString(f.name), 9, _hoisted_8))
            }), 128))
          ], 8, _hoisted_7))
        }), 128))
      ], 40, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label small" }, "Larghezza (cm)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          step: "0.01",
          min: "0",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempWidth) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.tempWidth,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label small" }, "Altezza (cm)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control form-control-sm",
          type: "number",
          step: "0.01",
          min: "0",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tempHeight) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.tempHeight,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label small" }, "Border Radius", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control form-control-sm",
        type: "text",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.borderRadius) = $event)),
        placeholder: "10px"
      }, null, 512), [
        [_vModelText, _ctx.model.borderRadius]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small" }, "Colore di sfondo", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control form-control-sm",
        type: "color",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.backgroundColor) = $event))
      }, null, 512), [
        [_vModelText, _ctx.model.backgroundColor]
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, [
        _createVNode(_component_toggler, {
          class: "me-1",
          modelValue: _ctx.model.isActive,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.isActive) = $event))
        }, null, 8, ["modelValue"]),
        _cache[15] || (_cache[15] = _createTextVNode(" Template attivo "))
      ])
    ])
  ]))
}